export default "__VITE_ASSET__DVgYS5aV__"